import React from 'react';
import styled from 'styled-components';
import {Row, ContenedorForm, HeaderForm, CuerpoForm, TituloForm, ContainerCol } from '../componentes_generales/componentes_formulario/contenedores';
import {LabelForm } from '../componentes_generales/componentes_formulario/labels';
import AgGridRender from '../componentes_generales/grid/ag_grid_render';
import global_axios from '../../funciones_globales/interaccionapi';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { cambiar_VisualizacionLoading } from '../../actions/generales/act_gen01';
import { generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm } from '../../actions/generales/act_gen03';
import { getItemDatosSesion } from '../../funciones_globales/manejosesion';
import ReactSelectAsync from '../componentes_generales/componentes_formulario/selects/react-select-async';
import { InputText }  from '../componentes_generales/componentes_formulario/inputs/inputtext';

const PaginationLabels = styled.div`
    font-size: 12px;
`;

const PaginationButtons = styled.div`
    margin-bottom:10px;
`;

const ButtonUnion = styled.button`
    height: 25px;
    padding: 0px 10px;
    font-size: 11px;
    z-index: 0;
`;

class FormAdmin05 extends React.Component{   
  constructor(props) {
    super(props);
    this.state = {  

      detalleParametro:[],
      codigo_parametro_seleccionado:'',
      codigo_parametro:'',
      descripcion:'',
      referencia:'',
      observacion:'',
      mostrar:false,
      esCreacion:false,

      
      usuario:'',
      
      columnDefs: [ 
                    {   header: "Código",
                        field: "Codigo",
                        width: 100,
                        type: "string"
                    },
                    {   header: "Descripcion",
                        field: "Descripcion",
                        width: 250,
                        type: "string"
                    },
                    {   header: "Signo",
                        field: "Signo",
                        width: 100,
                        type: "string"
                    },
                    {   header: "Referencia",
                        field: "Referencia",
                        width: 150,
                        type: "string"
                    },
                    {   header: "Observación",
                        field: "Observacion",
                        width: 200,
                        type: "string"
                    }         
                  ],
              
        pagination: {
          totalFilas: 0,
          totalFilasPorPagina: 0,
          primaraFilaPagina: 0,
          ultimaFilaPagina: 0,
      },  
    };

    this.gridOptions = {
      enableColResize: true,
      enableSorting: true,
      enableFilter: true,
      rowSelection: "single",
      suppressScrollOnNewData: true,
      paginationAutoPageSize:true,
      pagination: true,
      suppressPaginationPanel: true,
      onRowDoubleClicked: event => {
        let parametro = event.data;
        //this.getAsientoById(movimiento);
        this.cargarParametroModificar(parametro) 
      },
      onPaginationChanged: () => {
        if(!this.api){
            return;
        }
        let totalFilas = this.api.paginationGetRowCount();
        let totalFilasPorPagina = this.api.paginationGetPageSize();
        let ultimaFilaPagina = (totalFilasPorPagina * (this.api.paginationGetCurrentPage()+1));
        let indexPage = this.api.paginationGetCurrentPage();

        if( ultimaFilaPagina >  totalFilas){
            ultimaFilaPagina = totalFilas;
        }
   
        let pagination = {
            totalFilas: totalFilas,
            totalFilasPorPagina: totalFilasPorPagina,
            primaraFilaPagina: (totalFilasPorPagina * (indexPage + 1) - totalFilasPorPagina + 1),
            ultimaFilaPagina: ultimaFilaPagina
        };
       
        this.setState({pagination});
      },
    };

    this.onGridReady = this.onGridReady.bind(this);   
    this.submit = this.submit.bind(this);
    this.limpiar = this.limpiar.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.getParametrosTabla = this.getParametrosTabla.bind(this);
    this.cargarDetalleParametro=this.cargarDetalleParametro.bind(this);
    this.cargarParametroModificar = this.cargarParametroModificar.bind(this);
    this.habilitarCreacion = this.habilitarCreacion.bind(this);
  }  
  
  habilitarCreacion(){
   
    if(this.state.codigo_parametro_seleccionado!==null && this.state.codigo_parametro_seleccionado!== undefined && this.state.codigo_parametro_seleccionado!==''){
      this.setState({esCreacion:true})
    }else{
      alert('Debe seleccionar un parametro para poder continuar...')
    }
  }
  cargarParametroModificar(parametro){
    
    if(parametro!==null && parametro!==undefined){
      console.log(parametro)
       this.setState({
          codigo_parametro:(parametro.Codigo===null)?'':parametro.Codigo,
          descripcion:(parametro.Descripcion===null)?'':parametro.Descripcion,
          signo:(parametro.Signo===null)?'':parametro.Signo,
          referencia:(parametro.Referencia===null)?'':parametro.Referencia,
          observacion:(parametro.Observacion===null)?'':parametro.Observacion,
          mostrar:true
       })
    }
  }
  
  
  cargarDetalleParametro(){
    this.props.cambiar_VisualizacionLoading(true);
    if(this.state.codigo_parametro_seleccionado==='' || this.state.codigo_parametro_seleccionado===null || this.state.codigo_parametro_seleccionado===undefined){
      this.props.cambiar_VisualizacionLoading(false);
      alert('Seleccione un código de parametro')
      return;
    }
    console.log(this.state.codigo_parametro_seleccionado)
      let query = '?&tabla='+this.state.codigo_parametro_seleccionado.value.toString();
      this.setState({detalleParametro:[]})
      global_axios({
        method: 'GET',
        url: 'parametros/cargar_parametros/detalle/busqueda'+query
      }).then((response)=>{
          let detalleParametro=response.data;
           this.setState({detalleParametro});
          this.props.cambiar_VisualizacionLoading(false);
      }).catch((error) => {
        this.props.cambiar_VisualizacionLoading(false);
        alert('No se pudo cargar el detalle de parametros');
      })
      
  }

  getParametrosTabla(input, callback){
        if (input.toString().length >= 2 ){
            let ruta= 'parametros/cargar_parametros/busqueda/asincrona'
            let cadena_busq = '?cadena_busq=' + input;
             global_axios.get(ruta + cadena_busq)
            .then(response => response.data)
            .then(data => callback(null, {
                options: data.map(item => ({value: item.Codigo.toString().toUpperCase(), label: `${item.Descripcion.toString().toUpperCase()}` })),
                complete: true        
            }))
            .catch((err)=>{
                console.log('Error al cargar datos de catálogos desde API: ' + err);
            });
        }   
    }
 

  submit(e){
    e.preventDefault();
    if(this.state.mostrar && this.state.codigo_parametro_seleccionado!== null && this.state.codigo_parametro_seleccionado!== undefined){
          this.props.cambiar_VisualizacionLoading(true);
          var sendData= {};
          sendData.Usuario = this.state.usuario;
          sendData.codigo_parametro=this.state.codigo_parametro;
          sendData.descripcion= this.state.descripcion;
          sendData.signo= this.state.signo;
          sendData.referencia= this.state.referencia;
          sendData.observacion=this.state.observacion;
          sendData.tabla= this.state.codigo_parametro_seleccionado.value.toString();
          sendData.idRegAudit=this.props.idRegAudit;
          let url= (this.state.esCreacion)?'parametros/crear_parametro/':'parametros/modificar_parametros/';
          let mensaje=  (this.state.esCreacion)?'Parametro Creado Con Exito':'Parametro Modificado Con Exito';
          
          console.log(url)
          global_axios(
            { method: 'POST',
              url:url,
              data: sendData
            }
          )
          .then(()=>{
            this.setState({codigo_parametro:'',
                          descripcion:'',
                          signo:'',
                          referencia:'',
                          observacion:'',
                          mostrar:false,
                          esCreacion:false}, ()=>{ this.cargarDetalleParametro();})
            this.props.cambiar_VisualizacionLoading(false);
            
            alert(mensaje)
          })
          .catch((err)=>{
            console.log(err)
              this.props.cambiar_VisualizacionLoading(false);
              alert(err.response?err.response.data.msg:err.message);  
              //alert('No se pudo procesar la transacción...');
          });
      }else{
        alert("Seleccione un parametro del grid para proceder a modificarlo")
      } 
     
  }
  onGridReady(params) {
    this.api = params.api;
    this.columnApi = params.columnApi;
  }
  
  componentDidMount() {
    Promise.all([
        getItemDatosSesion('usuario'),
        this.props.generar_LogAuditoriaIngresoForm('1004'), 
    ])
    .then(([usuario]) => {
      this.setState(
        {
          usuario
        }) 
    })
    .catch(err => {
      console.log(err);
    });        
  }

  componentWillUnmount(){
    this.props.generar_LogAuditoriaSalidaForm('1004');
  } 
  limpiar(){
    this.setState({
      detalleParametro:[],
      codigo_parametro:'',
      descripcion:'',
      signo:'',
      referencia:'',
      observacion:'',
      mostrar:false,
      esCreacion:false
    });
  }


  handleInputChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }
  
  render(){        
        return(
          <ContenedorForm porc_ancho={70}>
            <HeaderForm>
              <TituloForm>Mantenimiento Parametro</TituloForm>
            </HeaderForm>
            <CuerpoForm>
            <Row>
                <ContainerCol className='col-sm-5' margen_arriba='10' margen_abajo='10'>
                    <LabelForm>Código Parametro:</LabelForm>
                    <ReactSelectAsync value={this.state.codigo_parametro_seleccionado}  func_loadOptions={this.getParametrosTabla} func_onChange={(value)=>{this.setState({codigo_parametro_seleccionado: value,detalleParametro:[]},()=>{this.limpiar()});}} /*func_onBlur={(value)=>{this.setCuenta(value)}}*//>
                </ContainerCol>
                <ContainerCol className='col-sm-2' margen_arriba='30' margen_abajo='10'>
                    <div className='input-group'>
                        <span className='input-group-btn'>
                            <ButtonUnion type='button' className='btn btn-success btn-sm' onClick={this.cargarDetalleParametro}><i className='fa fa-search'></i>Buscar</ButtonUnion>                
                        </span>
                    </div>
                </ContainerCol>
                {
                    this.state.mostrar?
                    <ContainerCol className='col-sm-2' margen_arriba='30' margen_abajo='10'>
                      <div className='input-group'>
                          <span className='input-group-btn'>
                              <ButtonUnion type='button'  className='btn btn-info btn-sm' onClick={this.habilitarCreacion}><i className='fa fa-plus'></i>Crear</ButtonUnion>                
                          </span>
                      </div>
                  </ContainerCol>
                  :
                  null
                }
                
              </Row>
              <Row>
                <div className='col-md-12'>   
                      <AgGridRender altura='200px' data={this.state.detalleParametro} columnas={this.state.columnDefs}
                      gridOptions={this.gridOptions} onGridReady={this.onGridReady}/>
                  </div>
                  <div className="col-xs-12 col-sm-12">
                      <Row>
                          <ContainerCol className="col-xs-12 col-sm-12">
                              <PaginationLabels>
                                  {this.state.pagination.primaraFilaPagina} a {this.state.pagination.ultimaFilaPagina} de {this.state.pagination.totalFilas}
                              </PaginationLabels>
                              <PaginationButtons>
                                  <div className="btn-group btn-group-xs" role="group">
                                      <button style={{height:'30px'}} type="button" className="btn btn-default" onClick={() => this.api.paginationGoToFirstPage()}>
                                          <i className="fa fa-angle-double-left fa-fw"></i>Ir al inicio
                                      </button>
                                      <button style={{height:'30px'}} type="button" className="btn btn-default" onClick={() => this.api.paginationGoToPreviousPage()}>
                                          <i className="fa fa-angle-left fa-fw"></i>Anterior
                                      </button>
                                      <button style={{height:'30px'}} type="button" className="btn btn-default" onClick={() => this.api.paginationGoToNextPage()}>
                                          Siguiente<i className="fa fa-angle-right fa-fw"></i>
                                      </button>
                                      <button style={{height:'30px'}} type="button" className="btn btn-default" onClick={() => this.api.paginationGoToLastPage()}>
                                          Ir al final<i className="fa fa-angle-double-right fa-fw"></i>
                                      </button>
                                  </div>
                              </PaginationButtons>
                          </ContainerCol>
                      </Row>
                  </div>
              </Row>
              {
                this.state.mostrar?
                <Row>
                    <ContainerCol className='col-sm-1'>
                        <LabelForm>Código.:</LabelForm>
                    </ContainerCol>
                    <ContainerCol className='col-sm-2'>
                    <InputText name='codigo_parametro' value={this.state.codigo_parametro} disabled={!this.state.esCreacion} onChange={this.handleInputChange} type="text" className='form-control input-sm'/>
                    </ContainerCol>      
                    <ContainerCol className='col-sm-1'>                    
                        <LabelForm>Descripción</LabelForm>
                    </ContainerCol> 
                    <ContainerCol className='col-sm-4'>
                      <InputText name='descripcion' value={this.state.descripcion} onChange={this.handleInputChange} type="text" className='form-control input-sm'/>
                    </ContainerCol>
                    <ContainerCol className='col-sm-1'>                    
                        <LabelForm>Signo</LabelForm>
                    </ContainerCol> 
                    <ContainerCol className='col-sm-3'>
                      <InputText name='signo' value={this.state.signo}  onChange={this.handleInputChange} type="text" className='form-control input-sm'/>
                    </ContainerCol>   
              </Row>
              :
              null
              }
              {
                 this.state.mostrar?
                 <Row margen_arriba={10}>
                      <ContainerCol className='col-sm-1'>                    
                          <LabelForm>Referencia</LabelForm>
                      </ContainerCol> 
                      <ContainerCol className='col-sm-3'>
                        <InputText name='referencia' value={this.state.referencia}  onChange={this.handleInputChange} type="text" className='form-control input-sm'/>
                      </ContainerCol>   
                      <ContainerCol className='col-sm-1'>
                          <LabelForm>Observación:</LabelForm>
                      </ContainerCol>
                      <ContainerCol className='col-sm-7'>
                      <InputText name='observacion' value={this.state.observacion} onChange={this.handleInputChange} type="text" className='form-control input-sm'/>
                      </ContainerCol>        
                </Row>
                :
                null
              }
              <Row margen_arriba={10}>  
                <form onSubmit={this.submit.bind(this)}> 
                    <div className='col-md-12'>
                      <div className='btn-group pull-right'>
                        <button type='submit' className='btn btn-primary btn-sm'><i className='fa fa-floppy-o fa-lg'></i> Guardar </button>
                        <button type='button' className='btn btn-default btn-sm' onClick={this.limpiar}><i className='fa fa-trash-o fa-lg'></i> Limpiar </button>
                      </div>
                    </div>                  
                </form>
              </Row>  
            </CuerpoForm>
          </ContenedorForm>
      );
  }
}

const mapStateToProps = ((state) => {
  
  return {  isVisibleLoading: state.ui.isVisibleLoading,
            Usuario: state.sesion.valoresSesionForm.Usuario,
            idRegAudit: state.sesion.valoresSesionForm.IdRegAudit}
});

const mapDispatchToProps = ((dispatch) => {  
  return bindActionCreators({ cambiar_VisualizacionLoading, generar_LogAuditoriaIngresoForm,
                              generar_LogAuditoriaSalidaForm }, dispatch)
});

export default connect (mapStateToProps, mapDispatchToProps)(FormAdmin05);